import { extendBase } from '@/scripts/Components/Utilities/DataProviderBaseComponent';

export default extendBase({
  props: {
    videoCollectionImplementationData: {
      type: Object,
      required: true,
    },
  },

  methods: {
    fetchData() {
      const { fetchers } = this.videoCollectionImplementationData;
      return fetchers.info();
    },
  },
});
